// extracted by mini-css-extract-plugin
export default {"table_text":"DeviceModal_table_text__lB-LS","red":"DeviceModal_red__REwsr"};